/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import React from 'react';
import BaseComponent from './BaseCom';
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Auth from '../shared/Auth';
import NewDashboard from './dashboard/NewDashboard';

class Dashboard extends BaseComponent {
    async componentDidMount() {
        await this.getSettings();
        Auth.getLogin(u => {
            if(u)
                this.setState({ user: u });
        });
    }
    render() {
        if(!this.state.user)
            return null;
        if(Auth.hasRole('dashboard'))
            return <NewDashboard />
        else if(this.state.MODEL === 'MNF')
            this.props.navigate('/purchase-order')
        else {
            this.props.navigate('/calendar');
            return null;
        }
            
    }
}

export default withParamsAndNavigate(Dashboard);